// extracted by mini-css-extract-plugin
export default {"wrapper":"AlertInfo_wrapper__gXqpQ","alert-title":"AlertInfo_alert-title__P295h"};